import { Box } from "@mui/material";
import { Tag } from "~/operations";
import { ComplianceFramework as ListComplianceFramework } from "../types";
import { ComplianceFramework } from "./Framework";
import { CISIcon } from "~/images/compliance-entry-page/CISIcon";
import { CsaIcon } from "~/images/compliance-entry-page/CsaIcon";
import { HIPAAIcon } from "~/images/compliance-entry-page/HIPAAIcon";
import { ISOIcon } from "~/images/compliance-entry-page/ISOIcon";
import { NistIcon } from "~/images/compliance-entry-page/NistIcon";
import { SOCIcon } from "~/images/compliance-entry-page/SOCIcon";
import { PCIIcon } from "~/images/compliance-entry-page/PCIIcon";
import { VdaIcon } from "~/images/compliance-entry-page/VdaIcon";
import { EuIcon } from "~/images/compliance-entry-page/EuIcon";
import { BsiIcon } from "~/images/compliance-entry-page/BsiIcon";

type Props = {
  iconKey: Tag | undefined;
};

export function FrameworkIcon({ iconKey }: Props) {
  const sizeProps = { fontSize: 32 };

  if (!iconKey) {
    return <Box sx={{ ...sizeProps }} />;
  }

  const matchIcon = () => {
    switch (iconKey.value) {
      case "bsi":
        return <BsiIcon sx={{ ...sizeProps }} />;
      case "cis":
        return <CISIcon sx={{ ...sizeProps }} />;
      case "csa-ccm":
        return <CsaIcon sx={{ ...sizeProps }} />;
      case "nis2":
        return <EuIcon sx={{ ...sizeProps }} />;
      case "hhs":
        return <HIPAAIcon sx={{ ...sizeProps }} />;
      case "iso":
        return <ISOIcon sx={{ ...sizeProps }} />;
      case "nist":
        return <NistIcon sx={{ ...sizeProps }} />;
      case "soc":
        return <SOCIcon sx={{ ...sizeProps }} />;
      case "pci":
        return <PCIIcon sx={{ ...sizeProps }} />;
      case "vda":
        return <VdaIcon sx={{ ...sizeProps }} />;
      default:
        return <Box />;
    }
  };

  return matchIcon();
}

type UseFrameworkProps = {
  framework?: ComplianceFramework | ListComplianceFramework;
};

export const useFrameworkIcon = ({ framework }: UseFrameworkProps) => {
  const iconKey = framework?.tags?.find((tag) => tag.key === "mondoo.com/icon");

  return { iconKey };
};
